import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl';
import { Row } from 'reactstrap';
import Toast from '../../helpers/Toast';
import { GetStatusHistoryDTO } from '../../models/Status/GetStatusHistoryDTO';
import { GetStatusPaginatedDTO } from '../../models/Status/GetStatusPaginatedDTO';
import { AssistanceService } from '../../services/AssistanceService';
import TableComponent from '../TableComponent';
import { CircularProgress } from '@mui/material';

export type StatusHistoryProps = {
    assistanceId: number;
    reloadExecutions: boolean;
    mode: "workshop" | "backoffice";
}

function StatusHistoryTable({ assistanceId, reloadExecutions, mode }: StatusHistoryProps) {

    const assistanceService = new AssistanceService();
    const pageSizes: number[] = [5, 15, 30];
    const [data, setData] = useState<GetStatusHistoryDTO[]>([]);
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);
    const [reload, setReload] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingCount, setLoadingCount] = useState<number>(0);

    const columns = React.useMemo(
        () => [
            {
                Header: "Data de Alteração",
                accessor: "date",
                width: 25,
                Cell: ({ value }: { value: any }) => {
                    const dateObject = new Date(value);
                    const formattedDate = dateObject.toLocaleDateString('pt-PT');
                    const formattedTime = dateObject.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });
                    return <span>{formattedDate} {formattedTime}</span>;
                }
            },            
            {
                Header: "Estado",
                accessor: "statusName",
                width: 30,
            },
            {
                Header: "Técnico",
                accessor: "userName",
                width: 30,
            },
        ],
        [],
    );
    
    

    const fetchData = async (currentPage: number, pageSize: number) => {
        var data: GetStatusPaginatedDTO = {
            assistanceId: assistanceId,
            currentPage: currentPage,
            pageSize: pageSize,
        }

        setLoading(true);
        var response = await assistanceService.GetStatusHistory(data);

        console.log(response)

        if (response.success === false) {
            setData([]);
            setGoToPage(0);
            Toast.Show("error", response.message);
            return;
        }

        setData(response.items);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(currentPage);
        setGoToPage(0);

        if (response.totalPages > 0 && currentPage > response.totalPages) {
            setGoToPage(1);
        }
        
        setLoading(false);
        setLoadingCount(1);
    }

    useEffect(() => {
        fetchData(currentPage, pageSize);
        setReload(false);
    }, [reload]);

    return (
        <div>
            <Row style={{ margin: "1rem 0px" }}>
                <h5><FormattedMessage id={"Screens.Assistances.Status.Table.Title"}></FormattedMessage></h5>
                <TableComponent
                    columns={columns}
                    data={data}
                    goToPage={goToPage}
                    initialPage={currentPage}
                    pageCount={pageCount}
                    initialPageSize={pageSize}
                    pageSizes={pageSizes}
                    manualPagination={true}
                    loading={isLoading}
                    fetchData={fetchData}
                    initialSortBy={[]}
                    disableSortBy={true}
                />
            </Row>
            {loading === true && loadingCount !== 1 && (
                <div className="loading">
                    <span>
                        {" "}
                        <FormattedMessage id="Common.Loading.DataLoading" />
                        ...{" "}
                    </span>
                    <CircularProgress style={{ marginLeft: "10px" }} size={"25px"} />
                </div>
            )}
        </div>
    )
}

export default StatusHistoryTable